import React, { useState } from 'react'
import classes from "./style.module.scss";

const AdminComment = ({comment, response}) => {

    return (
        <>
            <div className={`${classes.enquiryCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                    <div className='flex items-center mb-4'>
                        <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>
                            Admin Comment
                        </div>
                    </div>
                    {response && <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Response sent</div>
                            <div className={`${classes.infoValue}`}>{response}</div>
                        </div>
                    </div>}
                    {/* {comment && <div className={`${classes.infoWrapper}`}>
                        <div className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>Internal Comment</div>
                            <div className={`${classes.infoValue}`}>{comment}</div>
                        </div>
                    </div>} */}
                </div>
            </div>
        </>
    )
}

export default AdminComment